/**
 *  Legend script file
**/

import capitalize from '@/utils/capitalize'
import { ADVERT_TYPES } from '@/utils/mapUtils'
import { ADVERT_TYPE_LABELS } from '@/utils/advertOptions'

export default {
  name: 'Legend',
  mixins: [],
  components: {},
  props: {},
  data () {
    return {
      ADVERT_TYPES,
      ADVERT_TYPE_LABELS
    }
  },
  computed: {
  },
  methods: {
  },
  filters: {
    capitalize
  }
}
